import React from 'react';
import { Select as ASelect, Form } from 'antd';

// import style from './antd.module.sass';
import { IProps } from './component';


const { Option } = ASelect;

export const Select = (props: IProps) => {
    const properties = props.json.properties;
    const data = props.json.data;
    const options = (data && !data.async && data.options) ? data.options.map((k, index) => <Option key={index} value={k.value}>{k.label}</Option>) : []

    return (
        <Form.Item
            className={'a8-form-item override-common'}
            label={properties.label || 'Selection'}
        >
            <ASelect
                data-test-id="properties"
                // className={style.SelectformCtlCustom}
                id={props.id}
                getPopupContainer={() => document.getElementById(props.id) as any}
                dropdownClassName='select-dropdown'
                style={{ width: '100%' }}
                placeholder={properties.placeholder || ''}
                open={props.open!}
            >
                {options}
            </ASelect>
        </Form.Item>

    )
}
